export default class APIResponse {
    constructor(data, status, code, message) {
        this.data = data;
        this.status = status;
        this.code = code;
        this.message = message;
    }
}